import { useEffect, useState } from "react";
import { getDevelopmentalRange } from "@/lib/api";

// Final ZPD phase — read-only teacher panel: per structural skill, independent level · supported level · ordinal ZPD span · support pattern ·
// trajectory · status · evidence. Multidimensional by design: no global composite is shown or computed.
const ROW = "text-[13px] leading-snug text-stone-700";
export default function DevelopmentalRangePanel({ sessionId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let live = true;
    if (sessionId) getDevelopmentalRange(sessionId).then((d) => { if (live) setData(d); }).catch(() => { if (live) setData(null); });
    return () => { live = false; };
  }, [sessionId]);
  if (!data) return null;
  return (
    <section data-testid="developmental-range-panel" className="mt-6 max-w-2xl rounded-2xl border border-stone-300 bg-white px-5 py-4">
      <h3 className="text-[12px] font-semibold uppercase tracking-[0.12em] text-stone-800">Developmental range by structural skill</h3>
      {!data.domains.length ? <p data-testid="dr-empty" className={`mt-2 ${ROW} text-stone-500`}>No comparable structural episodes with classified support yet.</p> : null}
      <div className="mt-3 space-y-4">
        {data.domains.map((d, i) => (
          <div key={d.comparable_group} data-testid={`dr-domain-${i}`} className="border-t border-stone-200 pt-3">
            <div className="text-[12px] font-semibold uppercase tracking-[0.1em] text-[#8C3A2A]">{d.teacher.heading}</div>
            <dl className={`mt-1 grid grid-cols-[9rem_1fr] gap-x-3 gap-y-1 ${ROW}`}>
              <dt className="text-stone-500">Independent level</dt><dd data-testid={`dr-independent-${i}`}>{d.teacher.independent}</dd>
              <dt className="text-stone-500">Supported level</dt><dd data-testid={`dr-supported-${i}`}>{d.teacher.supported}</dd>
              <dt className="text-stone-500">ZPD</dt><dd data-testid={`dr-zpd-${i}`}>{d.teacher.zpd}</dd>
              {d.teacher.current_support_pattern ? <><dt className="text-stone-500">Current support</dt><dd>{d.teacher.current_support_pattern}</dd></> : null}
              <dt className="text-stone-500">Trajectory</dt><dd>{d.teacher.trajectory}</dd>
              <dt className="text-stone-500">Status</dt><dd data-testid={`dr-status-${i}`}>{d.teacher.status}</dd>
              <dt className="text-stone-500">Evidence</dt><dd>{d.teacher.evidence} {d.evidence_label}</dd>
            </dl>
          </div>
        ))}
      </div>
      <p className="mt-3 text-[11px] text-stone-400">Ordinal developmental spans per skill · instructional descriptors, not grades · no overall score is computed.</p>
    </section>
  );
}
